export const netsuiteAccioneRoles = {
  sideNavActions: {
    netsuitePbi: ['Admin', 'Chief', 'PowerBiViewer', 'PowerBiWsNetsuite'],
    departments: [],
    salesOrders: [],
    finishedGood: [],
    pallets: [],
    dayStar: [],
    delivery: [],
  },
};
